export default __webpack_public_path__ + "static/media/beat-my-high-score.5c1e4fb9.png";